import styled from 'styled-components/native';
import React from 'react';
import {tr} from '../../translations';
import TextGeneric from '../textGeneric';
import {useTheme} from 'styled-components';
import {Theme} from '../../theme/lightTheme';
import GenericButton from '../button';
import useResponsiveDimensions from '../../utils/hooks/useResponsiveDimensions';
import {ActivityIndicator, Platform} from 'react-native';
import Animated, {FadeInLeft, FadeOut} from 'react-native-reanimated';
import ProgressiveImage from '../progressiveImage';
import {TabNewsResultsBoxProps} from '../../interfaces/components/tabNewsResultsBox';

const Container = styled.View`
  width: 100%;
  border-radius: 33px;
  overflow: hidden;
  background-color: ${({theme}) => theme.tabNews.cardBackground};
  padding: ${({theme}) => theme.text.s55}px;
`;
const Title = styled(TextGeneric)`
  color: ${({theme}) => theme.settings.icon};
  font-size: ${({theme}) => theme.text.s55}px;
`;
const Subtitle = styled(TextGeneric)`
  color: ${({theme}) => theme.text.dark};
  font-size: ${({theme}) => theme.text.s6}px;
  padding-top: ${({theme}) => theme.text.s6 / 2}px;
`;
const ViewAllButton = styled(GenericButton)<{buttonWidth: string}>`
  width: ${({buttonWidth}) => buttonWidth};
  align-self: center;
  margin-top: ${({theme}) => theme.text.s55}px;
`;
const TextContainer = styled.View`
  flex: 1;
`;
const ImageContainer = styled.View`
  width: ${({theme}) => theme.text.s1 * 2.3}px;
  aspect-ratio: 1;
`;
const Image = styled(ProgressiveImage)`
  width: 100%;
  height: 100%;
`;
const Row = styled.View`
  width: 100%;
  flex-direction: row;
  align-items: center;
`;
/**
 * `TabNewsResultsBox` is a React component.
 *
 * @component
 * @returns {React.ReactElement} A React functional component that renders the TabNewsResultsBox component.
 */
const TabNewsResultsBox: React.FC<TabNewsResultsBoxProps> = ({
  style,
  numberOfResults,
  onViewAllPress,
  isLoading,
}: TabNewsResultsBoxProps): React.ReactElement => {
  const theme = useTheme() as Theme;
  const {getByScreenSize} = useResponsiveDimensions();

  return (
    <Container style={style}>
      <Row>
        <TextContainer>
          <Row>
            <Animated.View
              key={isLoading + ''}
              entering={FadeInLeft}
              exiting={FadeOut}>
              <Title semiBold>
                {isLoading ? (
                  <ActivityIndicator
                    size={theme.text.s55}
                    color={theme.settings.icon}
                  />
                ) : (
                  numberOfResults || '0'
                )}
              </Title>
            </Animated.View>
            <Title semiBold> {tr('tabNews.resultsFound')}</Title>
          </Row>
          <Subtitle>{tr('tabNews.subtitleResultsFound')}</Subtitle>
        </TextContainer>
        <ImageContainer>
          <Image
            hideLoader
            resizeMode={'contain'}
            defaultImage={require('../../assets/images/search.png')}
          />
        </ImageContainer>
      </Row>
      <ViewAllButton
        label={tr('tabNews.viewAllResultsFound')}
        disabled={
          !__DEV__ && (isLoading || !numberOfResults || numberOfResults === '0')
        }
        onPress={onViewAllPress}
        buttonWidth={getByScreenSize('90%', '20%')}
        isSmall={getByScreenSize(false, true)}
        radius={100}
      />
    </Container>
  );
};

export default TabNewsResultsBox;
